import { type IMeshGeometry, MeshParser } from '@seddi/mesh';

export class MeshLoader {
  static async load(url: string): Promise<IMeshGeometry> {
    const buttonsGeometryBinaryData = await fetch(url);
    const meshBuffer = await buttonsGeometryBinaryData.arrayBuffer();
    const mesh = MeshParser.Parse(meshBuffer);
    return mesh.geometry;
  }
}
